import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Footer from './components/Footer';
import AppPage from './components/AppPage'; // We will create this next
import AnalyticsTracker from './components/AnalyticsTracker'; // Import the tracker
import ErrorBoundary from './components/ErrorBoundary';
import NotFound from './components/NotFound';
import './App.css'; // We might create this later for App specific styles

function App() {
  useEffect(() => {
    if (document.getElementById('kofi-script')) return;
    const script = document.createElement('script');
    script.id = 'kofi-script';
    script.src = 'https://storage.ko-fi.com/cdn/widget/Widget_2.js';
    script.async = true;
    script.onload = () => {
      if (window.kofiwidget2) {
        window.kofiwidget2.init('Buy me a coffee', '#8e4bd1', 'P5P21VPHLG');
        window.kofiwidget2.draw();
      }
    };
    document.body.appendChild(script);
  }, []);

  return (
    <div className="wrapper"> {/* Matching the class from Hugo site */}
      <AnalyticsTracker /> {/* Add the tracker here */}
      <Header />
      <Routes>
        <Route path="/" element={<ErrorBoundary><Home /></ErrorBoundary>} />
        <Route path="/app" element={<ErrorBoundary><AppPage /></ErrorBoundary>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App; 